import React from 'react';
import { Spin } from 'antd';
import { Routes } from '../../../routes';
import LinksList from '../LinksList/LinksList';
import useSearchIds from '../../gql/hooks/useSearchIds';
 
const ListSearchItemsByIds = ( { type = 'courses', ids = [], title } ) => {
    const { items, searchIdError, searchIdLoading } = useSearchIds( type, ids );
 
    const handleEditClick = ( id ) => {
        if ( type === 'courses' ) { 
            window.open( Routes.EditCourse.buildPath( id ), '_blank' );
        } else {
            window.open( Routes.EditCurriculum.buildPath( id ), '_blank' );
        }
    };

    return (
        <div className="courses-list">
            { searchIdLoading && 
                 <Spin style={ { marginLeft: '280px', marginTop: '48px', marginBottom: '24px' } }/>
            }

            { !searchIdError && !searchIdLoading && items &&
                <LinksList 
                    title={ title ? title : type === 'courses' ? 'Courses' : 'Curricula' }
                    items={ items } 
                    handleClickCallback= { ( id ) => handleEditClick( id ) } 
                />
            }
        </div>
    );
};

export default ListSearchItemsByIds;
